import Immutable from 'immutable'
import { createSelector } from 'reselect'

// ------------------------------------
// Constants
// ------------------------------------
export const BEGIN_WORK = 'inf/autocomplete/BEGIN_WORK'
export const END_WORK = 'inf/autocomplete/END_WORK'
export const FETCH_SUGGESTIONS = 'inf/autocomplete/FETCH_SUGGESTIONS'
export const RECEIVE_SUGGESTIONS = 'inf/autocomplete/RECEIVE_SUGGESTIONS'
export const RECEIVE_SUGGESTIONS_ERROR = 'inf/autocomplete/RECEIVE_SUGGESTIONS_ERROR'

// ------------------------------------
// Actions
// ------------------------------------
export const beginWork = type => ({
  payload: {
    type,
  },
  type: BEGIN_WORK,
})
export const endWork = type => ({
  payload: {
    type,
  },
  type: END_WORK,
})
export const fetchSuggestions = (type, query) => ({
  payload: {
    query,
    type,
  },
  type: FETCH_SUGGESTIONS,
})
export const receiveSuggestions = (type, query, completions) => ({
  payload: {
    completions,
    query,
    type,
  },
  type: RECEIVE_SUGGESTIONS,
})
export const receiveSuggestionsError = (type, query) => ({
  payload: {
    query,
    type,
  },
  type: RECEIVE_SUGGESTIONS_ERROR,
})

// ------------------------------------
// Selectors
// ------------------------------------
export const makeSelectSuggestions = () => createSelector(
  (state, { query }) => query,
  (state, { type }) => type,
  state => state.autocomplete.get('suggestions'),
  (query, type, suggestions) => suggestions.getIn([type, query], Immutable.OrderedSet()),
)
export const makeSelectWorking = () => createSelector(
  (state, { type }) => type,
  state => state.autocomplete.get('working'),
  (type, working) => working.has(type),
)

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = Immutable.fromJS({
  errors: Immutable.Map(),
  suggestions: Immutable.Map(),
  working: Immutable.Set(),
})

export default function reducer(state = initialState, { payload, type }) {
  switch (type) {
    case BEGIN_WORK:
      return state.set('working', state.get('working').add(payload.type))

    case END_WORK:
      return state.set('working', state.get('working').delete(payload.type))

    case RECEIVE_SUGGESTIONS:
      return state
        .deleteIn(['errors', payload.type, payload.query])
        .setIn(['suggestions', payload.type, payload.query], Immutable.OrderedSet(payload.completions))

    case RECEIVE_SUGGESTIONS_ERROR:
      return state
        .setIn(['errors', payload.type, payload.query], true)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/modules/autocomplete.js